const epsilon = 0.1;
export const equal = (a, b) => a > b && a - b <= epsilon;

export const toFixedNumber = (num, digits, base) => {
  const pow = (base || 10) ** digits;
  return Math.round(num * pow) / pow;
};
